<template>
    <div>
        <BaseDatatable :module="`pages`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'PageList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'name',
          sortField: 'name',
          title: this.$translate.t('Name')
        },
        {
          name: 'url',
          sortField: 'url',
          title: this.$translate.t('Link')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Page List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/page/PageList.vue